import React, { useEffect, useState, useRef, useContext } from 'react';
import axiosInstance from './../axiosInstance';
import Logbook from './Logbook';
import MyUserContext from './../myUserContext';

const LogbookDropdown = ({ artId, userId, onClose, language, isOpen, initialLogbookDateTimes, initialArt }) => {
  const [artData, setArtData] = useState(initialArt || null);
  const [logbookDateTimes, setLogbookDateTimes] = useState(initialLogbookDateTimes || []);
  const [loading, setLoading] = useState(!initialLogbookDateTimes);
  const dropdownRef = useRef(null);

  const buildTitle = (category, language) => {
    if (language === "en") {
      if (category === 1) {
        return "My watch dates";
      } else if (category === 2) {
        return "My playing dates";
      } else if (category === 3) {
        return "My reading dates";
      }
      return "";
    } else {
      if (category === 1) {
        return "Даты моих просмотров";
      } else if (category === 2) {
        return "Даты, когда я играл(а)";
      } else if (category === 3) {
        return "Даты моих чтений";
      }
    }
    return "";
  }

  useEffect(() => {
    // alert(artId);
    // alert(initialLogbookDateTimes);
    // alert(!initialLogbookDateTimes);
    if (!initialLogbookDateTimes && !initialArt) {
      axiosInstance
        .get(`/arts/${artId}/`)
        .then((response) => {
          setArtData(response.data);
        })
        .catch((error) => {
          console.error(error);
        });

      const logbookUrl = userId 
        ? `/art/logbook/get?artId=${artId}&userId=${userId}` 
        : `/art/logbook/get?artId=${artId}`;
      
      axiosInstance
        .get(logbookUrl)
        .then((response) => {
          setLogbookDateTimes(response.data);
          setLoading(false);
        })
        .catch((error) => {
          console.error(error);
          setLoading(false);
        });
    } else {
      setArtData(initialArt);
      setLogbookDateTimes(initialLogbookDateTimes);
    }
  }, [artId, userId, initialLogbookDateTimes]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target) &&
        event.type === "mousedown"
      ) {
        onClose();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [onClose]);

  useEffect(() => {
    const preventParentInteraction = (event) => {
      if (dropdownRef.current && dropdownRef.current.contains(event.target)) {
        // Allow scrolling inside the dropdown
        const { scrollTop, scrollHeight, clientHeight } = dropdownRef.current;
        const isAtTop = scrollTop === 0;
        const isAtBottom = scrollTop + clientHeight === scrollHeight;

        if (
          (isAtTop && event.deltaY < 0) || // Prevent scrolling up when at the top
          (isAtBottom && event.deltaY > 0) // Prevent scrolling down when at the bottom
        ) {
          event.preventDefault();
        }
      }
    };

    const allowParentScroll = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        // Allow parent scrolling when the event target is outside the dropdown
        document.body.style.overflow = '';
      }
    };

    if (isOpen) {
      document.body.style.overflow = 'hidden'; // Prevent parent scrolling
      document.body.style.height = '100%'; // Ensure no scrolling
      document.addEventListener('wheel', preventParentInteraction, { passive: false });
      document.addEventListener('touchmove', preventParentInteraction, { passive: false });
    }

    return () => {
      document.body.style.overflow = ''; // Restore parent scrolling
      document.body.style.height = ''; // Restore height
      document.removeEventListener('wheel', preventParentInteraction);
      document.removeEventListener('touchmove', preventParentInteraction);
    };
  }, [isOpen]);

  if (loading) {
    return null; // Render nothing while loading
  }

  if (!artData) {
    return <div>Error loading art data.</div>;
  }

  return (
    <div
      ref={dropdownRef}
      className="pb-20 md:pb-0 fixed inset-x-0 bottom-0 bg-[#181818] border-t border-gray-500 shadow-lg max-h-[75vh] overflow-y-auto z-50 w-full md:w-1/4 md:mx-auto sm:max-h-[50vh] rounded-lg"
    >
      <div className="">
        <h2 className="sticky top-0 text-center text-lg font-bold text-white bg-[#5D6064] py-2">
          {buildTitle(artData.category, language)}
        </h2>
        <div className="flex justify-center my-2">
          <img
            className="object-cover rounded-lg max-w-[100px]"
            src={artData.thumbnailUrl}
            alt={artData.name || "Art Thumbnail"}
          />
        </div>
        <div className="flex justify-center">
          <Logbook
            initialDateTimes={logbookDateTimes}
            art={artData}
            language={language}
          />
        </div>
      </div>
    </div>
  );
};

export default LogbookDropdown;
